import {useEffect, useState} from "react";
import axios from "axios";
import {restUrl} from "../../../../apiUrl";
import {isEnglish} from "component/const/Functions";
import {useNavigate} from "react-router-dom";

export const AboutPre = ({testId}) => {
    
    const [fixed, setFixed] = useState();
    useEffect(() => {
        init()
    }, []);

    const nav = useNavigate()

    const init = async ()=>{
        if(!testId) return;
        const {data} = await axios.get(`${restUrl}/activity_test_view_header_create?test_id=eq.${testId}`);
        if (data.length === 0) return;
        setFixed(data[0])
        const endTime = new Date(data[0].test_end_time)
        setTimeLeft(Math.floor((endTime-new Date())/1000));
    }

    const [timeLeft, setTimeLeft] = useState(30)
    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(timeLeft - 1);
            if (timeLeft <= 0) {
                clearInterval(timer);
                alert("시험이 끝났습니다.");
                window.history.back();
            }
        },1000);
        return () => clearInterval(timer);
    }, [timeLeft]);

    if(!fixed){
        return null
    }

    return (
        <table>
            <thead>
            <tr>{Object.keys(fixed)?.map((key, index) => !isEnglish(key) &&
                <th key={`th${key}${index}`.toString()} dangerouslySetInnerHTML={{__html: key}}/>)}
                {timeLeft && <th>남은 시간</th>}
            </tr>
            </thead>
            <tbody>
            <tr>{Object.keys(fixed)?.map((key, index) => !isEnglish(key) &&
                <td key={`td${fixed[key].toString()}${index}`}>
                    {!Array.isArray(fixed[key])? fixed[key]
                        :fixed[key].map((it, idx) => {
                            return <>{it}{idx < fixed[key].length && <br/>}</>
                        })
                    }
                </td>
            )}
                {timeLeft && <td onClick={()=>nav(-1)}>{Math.floor(timeLeft/(60*60))}:{Math.floor(timeLeft/60)%60}:{timeLeft%60}</td>}
            </tr>
            </tbody>
        </table>
    )
}

export const partition = ',.|'
export const selectValPartition = '.|,'